import PropTypes from 'prop-types';
import { useState } from 'react';
import { useColorScheme, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

import gixLogo from 'assets/images/logo-gix.png';
import useOrgLogo from 'hooks/useOrgLogo';

export default function Logo({ dark = false, width = 200 }) {
  const orgLogoUrl = useOrgLogo();
  const [orgLogoFailed, setOrgLogoFailed] = useState(false);

  const src = orgLogoUrl && !orgLogoFailed ? orgLogoUrl : gixLogo;

  // Typical logo images are 2:1 or 3:1 width:height ratio, adjust as needed!
  const height = width / 2;
  return (
    <Box
      sx={{
        width,
        height,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img
        src={src}
        alt="GIX"
        width={width}
        height={height}
        style={{ position: 'relative', zIndex: 1, objectFit: 'contain' }}
        onError={() => {
          if (orgLogoUrl && !orgLogoFailed) setOrgLogoFailed(true);
        }}
      />
    </Box>
  );
}

Logo.propTypes = { dark: PropTypes.bool, width: PropTypes.number };